'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var device_consts = require('./device.consts-2b011893.js');

var getWindowDimensions = function () {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
    };
};
var useWindowDimensions = function () {
    var _a = tslib_es6.__read(React.useState(getWindowDimensions()), 2), windowDimensions = _a[0], setWindowDimensions = _a[1];
    React.useEffect(function () {
        var handleResize = function () {
            setWindowDimensions(getWindowDimensions());
        };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowDimensions;
};
var useIsSmallViewportWidth = function () {
    var width = useWindowDimensions().width;
    return width <= device_consts.SMALL_DEVICE_MAX_WIDTH;
};

exports.useIsSmallViewportWidth = useIsSmallViewportWidth;
exports.useWindowDimensions = useWindowDimensions;
